import { DataBean } from "../DataBean";

export class UBLInvoiceDoc extends DataBean {



    public async getUBLInventoryEntryDocumentTypes(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getUBLInventoryEntryDocumentTypes_Number", [id]);
    }

}
